import type { AssetAttribute } from '../../Services/serviceURL';
import type { SensorData } from './analysisTabSensorTypes';

export function createSensorsFromAssetDetails(
  attributes: AssetAttribute[],
  assetType: string | undefined,
  colorPalette: string[]
): SensorData[] {
  const sensors: SensorData[] = [];
  let colorIndex = 0;

  for (const attribute of attributes) {
    if (!attribute.channelId || !attribute.name) {
      continue;
    }
    sensors.push({
      id: `${attribute.channelId}-${colorIndex}`,
      channelId: attribute.channelId,
      sensorName: attribute.name,
      unit: attribute.unit || attribute.unitDescription || '',
      color: colorPalette[colorIndex % colorPalette.length],
      dataPoints: [],
      assetType: assetType || 'unknown',
    });
    colorIndex++;
  }

  return sensors;
}
